import { render, staticRenderFns } from "./loginTest.vue?vue&type=template&id=bca84888&scoped=true&"
import script from "./loginTest.vue?vue&type=script&lang=js&"
export * from "./loginTest.vue?vue&type=script&lang=js&"
import style0 from "./loginTest.vue?vue&type=style&index=0&id=bca84888&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca84888",
  null
  
)

export default component.exports